import { Component, Mixins } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BRow, BCol } from 'bootstrap-vue'
import WidgetMixin from '../../mixins/WidgetMixin'

@Component({
  components: {
    FontAwesomeIcon,
    BRow, BCol
  }
})
export default class WidgetNumber extends Mixins(WidgetMixin) {
  get rawLabel (): (key: string) => string|string[] {
    return key => {
      const data = this.widget?.datas.find(data => data.key === key) as KwixeoDashboard.AvailableWidgetData
      return data?.label2 ?? data?.label ?? ''
    }
  }

  get rawValue (): (key: string, compare?: boolean) => number {
    return (key, compare = false) => {
      let data: KwixeoDashboard.NumberDatas
      if (compare) {
        data = this.dashboardDataCompare as KwixeoDashboard.NumberDatas
      } else {
        data = this.dashboardData as KwixeoDashboard.NumberDatas
      }

      return data && key in data ? data[key] : 0
    }
  }

  get compareDifference (): (key: string) => string {
    return key => {
      const value = this.rawValue(key)
      const compareValue = this.rawValue(key, true)

      if (compareValue === 0) {
        return ''
      }

      const pourcent = Number(((value * 100) / compareValue).toFixed(2))
      const direction = pourcent > 0 ? '+' : '-'

      return '<span style="color: #9d9d9d;">N-1 : ' + this.formattedValue(key, true) + '</span>' +
      '<span class="font-weight-bold pl-3 text-' + (direction === '+' ? 'success' : 'danger') + '">' + direction + this.showNumber(pourcent) + ' %</span>'
    }
  }

  get formattedLabel (): (key: string) => number|string {
    return key => {
      const label = this.rawLabel(key)
      return Array.isArray(label) ? (this.rawValue(key) <= 1 ? label[0] : label[1]) : label
    }
  }

  get formattedValue (): (key: string, compare?: boolean) => number|string {
    return (key, compare = false) => {
      const value = this.rawValue(key, compare)

      if (Array.isArray(this.rawLabel(key))) {
        return value
      }

      if (key === 'count') {
        return this.showNumber(value, 0)
      }

      return this.formattedNumber(value)
    }
  }

  get extraDatas (): (key: string) => number|string {
    return key => {
      const label = this.formattedLabel(key)
      const value = this.formattedValue(key)
      if (Array.isArray(this.rawLabel(key))) {
        return value + ' ' + label
      }
      return label + ' : ' + value
    }
  }
}
